import { sortNamedListAlpha } from "../utils";

export function isHiddenCheckTypeSource(sourceName: string): boolean {
  return sourceName.replace(/\s+/g, "").toLowerCase() === "pdfgenerator";
}

export function checkTypeSourceNames(sources?: string[]): string[] {
  return sortNamedListAlpha(
    Array.from(new Set(sources ?? [])).filter(
      (source) => !isHiddenCheckTypeSource(source)
    )
  );
}
